<template>
  <multiple-lookup
    :model-value="modelValue"
    :config="config"
    :disabled="disabled"
    @update:model-value="emits('update:model-value', $event)"
  />
</template>

<script setup>
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import MultipleLookup from './multiple-lookup.vue';

defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:model-value']);

const config = new MultipleLookupConfig({
  title: globalTranslate('lookup.expirationStatuses') || 'Expiration Statuses',
  fetch: () => Promise.resolve([
    { name: globalTranslate('courseStatus.expired') || 'Expired', value: true },
    { name: globalTranslate('courseStatus.notExpired') || 'Not Expired', value: false },
  ]),
  toReadable: item => item.name,
});

</script>
